import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useNguonVet } from '../../su-dung-ai/nguon';
import { buocThoiGian } from '../nghiep-vu/khoang';
import { LOC_AI_MAC_DINH, thamSoLocLuot, type LocAi } from '../nghiep-vu/loc-ai';
import type { ThongKeAi, TruyVanThongKeAi } from '../nghiep-vu/types-thong-ke';
import { nktvKeys } from './keys';

const CU_SAU_MS = 60_000;

/**
 * Số liệu AI (`/vet/thong-ke-ai` của tenant, `/ai-usage/stats` của nền tảng — nguồn theo `NguonVet`). `buoc_thoi_gian`
 * SUY từ độ dài khoảng (`buocThoiGian`), không phải một ô chọn: 24 giờ gom theo ngày ra một cột, 90 ngày gom theo giờ
 * ra 2160 cột.
 */
export function useThongKeAi(tu: string, den: string, loc: LocAi = LOC_AI_MAC_DINH, bat = true) {
  const { kho, khoa } = useNguonVet();
  const tham = useMemo<TruyVanThongKeAi>(
    () => ({ tu, den, buoc_thoi_gian: buocThoiGian(tu, den), ...thamSoLocLuot(loc) }),
    [tu, den, loc],
  );
  return useQuery<ThongKeAi>({
    queryKey: nktvKeys.thongKeAi(khoa, tham),
    queryFn: () => kho.thongKeAi(tham),
    staleTime: CU_SAU_MS,
    enabled: bat,
  });
}
